module.exports = __webpack_public_path__ + "static/media/car-premium.7961b403.svg";